import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { AppContext } from "../../../context";
import { PopoverInput } from "../../../components/PopoverInput";
import { isAndroid, isBrowser, isIOS, isIphonePro, isIphoneProMax } from "../../Shared/utils/detect-devices";
import { BRANDS } from "../../../configs";

import styles from "./SovPassengerClassFieldInput.scss";

const SovPassengerClassFieldInput = ({
	id,
	className,
	selectedClass,
	classList,
	onChange
}) => {
	const [useAppState] = AppContext.useAppContext();

	return (
		<PopoverInput
			id={id}
			label={useAppState.getDictionary("class")}
			brand={useAppState.brand}
			value={selectedClass?.label}
			defaultCloseIcon={false}
			isGuestMobile={true}
			className={cx(className, {
				[styles[useAppState.brand]]: styles[useAppState.brand]
			})}
			icon={
				<span className={styles.listViewButton} focus-trap-toggle="true">
					<FontAwesomeIcon
						icon={faChevronDown}
						className={styles.listViewIcon}
					/>
				</span>
			}
			onChange={onChange}
			reactDOM={useAppState.reactDOM}
			appRoot={useAppState.appRoot}
			onClose={() => !!selectedClass}>
			{({ handleClose }) => (
				<fieldset
					className={cx(styles.container, {
						[styles.containerIOS]: isIOS() && useAppState.brand === BRANDS.SOV,
						[styles.containerIOSPro]:
						isIphonePro() && useAppState.brand === BRANDS.SOV,
						[styles.containerIOSMax]:
						isIphoneProMax() && useAppState.brand === BRANDS.SOV,
						[styles.containerAndroid]: !isBrowser() && isAndroid() && useAppState.brand === BRANDS.SOV,
					})}>
					<div className={styles.classListContainer}>
						{classList?.map(list => (
							<button
								type="button"
								key={list.id}
								onClick={() => {
									handleClose();
									onChange(list);
								}}
								className={cx(styles.classListItem, {
									[styles.classListItemselected]:
										selectedClass.label === list.label
								})}>
								{list.label}
							</button>
						))}
					</div>
				</fieldset>
			)}
		</PopoverInput>
	);
};

SovPassengerClassFieldInput.propTypes = {
	id: PropTypes.string,
	className: PropTypes.string,

	classList: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string,
			value: PropTypes.string
		})
	).isRequired,
	selectedClass: PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.string
	}).isRequired,
	onChange: PropTypes.func.isRequired
};

SovPassengerClassFieldInput.defaultProps = {
	id: undefined,
	className: undefined
};

export default SovPassengerClassFieldInput;
export { SovPassengerClassFieldInput };
